// Iter 83 — Extracted from TradeDoctor.jsx ResultsPhase (was inline JSX
// at ~lines 1300-1452). The "Trade Health Report" hero: large Health
// Score circle + 2-3 sentence Doctor Summary + exactly 3 Top Findings.
// Pure presentation — all data computed by the caller and passed in.
import React from "react";
import { AlertOctagon, Award, Sparkles } from "lucide-react";
import { FindingChip } from "./FindingChip";

export function TradeHealthReportHero({
  report, score, scoreColor, biggestRisk, biggestStrength, thisWeeksFix,
}) {
  return (
    <div
      data-testid="trade-health-report-hero"
      className="bt-card border border-[var(--bt-border)] rounded-sm p-6 space-y-5"
      style={{
        background:
          "linear-gradient(135deg, color-mix(in srgb, var(--bt-accent) 5%, var(--bt-surface)) 0%, var(--bt-surface) 70%)",
      }}
    >
      <div>
        <p className="bt-label text-[var(--bt-text-muted)]">Trade Health Report</p>
      </div>

      {/* Health Score + Doctor Summary */}
      <div className="flex flex-col md:flex-row md:items-center gap-6">
        <div
          className="shrink-0 w-28 h-28 rounded-full flex flex-col items-center justify-center border-4"
          style={{ borderColor: scoreColor }}
          data-testid="audit-score"
        >
          <span className="font-heading text-4xl" style={{ color: scoreColor }}>
            {score}
          </span>
          <span className="text-[10px] uppercase tracking-wider text-[var(--bt-text-muted)]">
            / 100
          </span>
        </div>
        <div className="flex-1 space-y-2">
          <p className="bt-label" style={{ color: scoreColor }}>
            {report?.score_label || "Audit"}
          </p>
          <p
            className="text-base md:text-lg leading-relaxed text-[var(--bt-text)]"
            data-testid="audit-headline"
          >
            {report?.headline || "Audit complete."}
          </p>
        </div>
      </div>

      {/* Top 3 Findings */}
      <div
        className="grid grid-cols-1 sm:grid-cols-3 gap-3"
        data-testid="audit-top-findings"
      >
        <FindingChip
          kind="risk"
          label="Biggest Risk"
          icon={<AlertOctagon className="w-4 h-4" />}
          color="var(--bt-loss)"
          title={biggestRisk?.title}
          detail={biggestRisk?.detail}
          empty="No major risk flagged."
          testid="finding-biggest-risk"
        />
        <FindingChip
          kind="strength"
          label="Biggest Strength"
          icon={<Award className="w-4 h-4" />}
          color="var(--bt-win)"
          title={biggestStrength?.title}
          detail={biggestStrength?.detail}
          empty="No clear strength yet — keep logging."
          testid="finding-biggest-strength"
        />
        <FindingChip
          kind="fix"
          label="This Week's Fix"
          icon={<Sparkles className="w-4 h-4" />}
          color="var(--bt-accent)"
          title={thisWeeksFix?.action}
          detail={thisWeeksFix?.why}
          empty="No immediate fix recommended."
          testid="finding-this-weeks-fix"
        />
      </div>
    </div>
  );
}
